import { formatTimeZone } from '@/pages/activity/components/formatTime';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
dayjs.extend(timezone);

export type IUTC = keyof typeof TIME_ZONE;
// 时区选项
export const TIME_ZONE = {
  'UTC-12:00': { label: '(UTC-12:00) 国际日期变更线西', UTC: 'Etc/GMT+12', value: 'UTC-12:00', diff: 12 },
  'UTC-11:00': { label: '(UTC-11:00) 中途岛，萨摩亚群岛', UTC: 'Etc/GMT+11', value: 'UTC-11:00', diff: 11 },
  'UTC-10:00': { label: '(UTC-10:00) 夏威夷、阿留申群岛', UTC: 'Etc/GMT+10', value: 'UTC-10:00', diff: 10 },
  'UTC-09:30': { label: '(UTC-09:30) 马克萨斯群岛', UTC: 'Pacific/Marquesas', value: 'UTC-09:30', diff: 9.5 },
  'UTC-09:00': { label: '(UTC-09:00) 阿拉斯加', UTC: 'Etc/GMT+9', value: 'UTC-09:00', diff: 9 },
  'UTC-08:00': { label: '(UTC-08:00) 太平洋时间(美国和加拿大)', UTC: 'Etc/GMT+8', value: 'UTC-08:00', diff: 8 },
  'UTC-07:00': { label: '(UTC-07:00) 山地时间(美国和加拿大)', UTC: 'Etc/GMT+7', value: 'UTC-07:00', diff: 7 },
  'UTC-06:00': { label: '(UTC-06:00) 中部时间(美国和加拿大)', UTC: 'Etc/GMT+6', value: 'UTC-06:00', diff: 6 },
  'UTC-05:00': { label: '(UTC-05:00) 东部时间(美国和加拿大)', UTC: 'Etc/GMT+5', value: 'UTC-05:00', diff: 5 },
  'UTC-04:00': { label: '(UTC-04:00) 大西洋时间(加拿大)', UTC: 'Etc/GMT+4', value: 'UTC-04:00', diff: 4 },
  'UTC-03:30': { label: '(UTC-03:30) 紐芬兰', UTC: 'America/St_Johns', value: 'UTC-03:30', diff: 3.5 },
  'UTC-03:00': { label: '(UTC-03:00) 格陵兰、巴西利亚', UTC: 'Etc/GMT+3', value: 'UTC-03:00', diff: 3 },
  'UTC-02:00': { label: '(UTC-02:00) 中大西洋', UTC: 'Etc/GMT+2', value: 'UTC-02:00', diff: 2 },
  'UTC-01:00': { label: '(UTC-01:00) 亚速尔群岛、佛得角群岛', UTC: 'Etc/GMT+1', value: 'UTC-01:00', diff: 1 },
  'UTC+00:00': { label: '(UTC+00:00) 都柏林,伦敦', UTC: 'GMT', value: 'UTC+00:00', diff: 0 },
  'UTC+01:00': { label: '(UTC+01:00) 柏林,巴黎', UTC: 'Etc/GMT-1', value: 'UTC+01:00', diff: -1 },
  'UTC+02:00': { label: '(UTC+02:00) 雅典', UTC: 'Etc/GMT-2', value: 'UTC+02:00', diff: -2 },
  'UTC+03:00': { label: '(UTC+03:00) 莫斯科', UTC: 'Etc/GMT-3', value: 'UTC+03:00', diff: -3 },
  'UTC+03:30': { label: '(UTC+03:30) 德黑兰', UTC: 'Asia/Tehran', value: 'UTC+03:30', diff: -3.5 },
  'UTC+04:00': { label: '(UTC+04:00) 第比利斯', UTC: 'Etc/GMT-4', value: 'UTC+04:00', diff: -4 },
  'UTC+04:30': { label: '(UTC+04:30) 客布尔', UTC: 'Asia/Kabul', value: 'UTC+04:30', diff: -4.5 },
  'UTC+05:00': { label: '(UTC+05:00) 伊斯兰堡,卡拉奇', UTC: 'Etc/GMT-5', value: 'UTC+05:00', diff: -5 },
  'UTC+05:30': { label: '(UTC+05:30) 欲奈,加尔各答,孟买,新德里', UTC: 'Asia/Colombo', value: 'UTC+05:30', diff: -5.5 },
  'UTC+05:45': { label: '(UTC+05:45) 加德满都', UTC: 'Asia/Katmandu', value: 'UTC+05:45', diff: -5.75 },
  'UTC+06:00': { label: '(UTC+06:00) 阿斯塔纳', UTC: 'Etc/GMT-6', value: 'UTC+06:00', diff: -6 },
  'UTC+06:30': { label: '(UTC+06:30) 仰光', UTC: 'Asia/Yangon', value: 'UTC+06:30', diff: -6.5 },
  'UTC+07:00': { label: '(UTC+07:00) 曼谷', UTC: 'Etc/GMT-7', value: 'UTC+07:00', diff: -7 },
  'UTC+08:00': { label: '(UTC+08:00) 北京、吉隆坡', UTC: 'Etc/GMT-8', value: 'UTC+08:00', diff: -8 },
  'UTC+08:45': { label: '(UTC+08:45) 尤克拉', UTC: 'Australia/Eucla', value: 'UTC+08:45', diff: -8.75 },
  'UTC+09:00': { label: '(UTC+09:00) 东京、首尔', UTC: 'Etc/GMT-9', value: 'UTC+09:00', diff: -9 },
  'UTC+09:30': { label: '(UTC+09:30) 达尔文、阿德莱德', UTC: 'Australia/Darwin', value: 'UTC+09:30', diff: -9.5 },
  'UTC+10:00': { label: '(UTC+10:00) 堪培拉,墨尔本,悉尼', UTC: 'Etc/GMT-10', value: 'UTC+10:00', diff: -10 },
  'UTC+10:30': { label: '(UTC+10:30) 豪助爵岛', UTC: 'Australia/Adelaide', value: 'UTC+10:30', diff: -10.5 },
  'UTC+11:00': { label: '(UTC+11:00) 所罗门群岛,新喀里多尼亚', UTC: 'Etc/GMT-11', value: 'UTC+11:00', diff: -11 },
  'UTC+12:00': { label: '(UTC+12:00) 斐济、奥克兰,惠灵顿', UTC: 'Etc/GMT-12', value: 'UTC+12:00', diff: -12 },
  'UTC+13:00': { label: '(UTC+13:00) 努库阿洛法,萨摩亚群岛', UTC: 'Etc/GMT-13', value: 'UTC+13:00', diff: -13 },
  'UTC+14:00': { label: '(UTC+14:00) 圣诞岛', UTC: 'Pacific/Kiritimati', value: 'UTC+14:00', diff: -14 }
};

/**
 * @description 根据传入UTC格式化时间戳
 */
export function formatTimestamp(timestamp: number, utc = 'UTC+08:00', format = 'YYYY年MM月DD日 HH:mm:ss') {
  return dayjs.tz(timestamp, TIME_ZONE[utc as IUTC]?.UTC ?? 'Etc/GMT-8').format(format);
}

interface ITime {
  start: number; //开始时间时间戳
  end: number; //结束时间时间戳
  startStr?: string; //开始时间字符串
  endStr?: string; //开始时间字符串
  isPermanent?: boolean;
}
export const timeRangerValue = (time: ITime, format: string, timeZone = 'UTC+08:00'): any => {
  return [
    time.startStr
      ? dayjs(time.startStr, format)
      : time.start
      ? dayjs(formatTimestamp(time.start, timeZone, format), format)
      : null,
    time.endStr
      ? dayjs(time.endStr, format)
      : time.end
      ? dayjs(formatTimestamp(time.end, timeZone, format), format)
      : null
  ];
};
export const changeTimeToZoom = (utc: string) => {
  return new Date().getTime() + (new Date().getTimezoneOffset() - TIME_ZONE[utc].diff * 60) * 60 * 1000;
};
export const timeRangerShow = (time: ITime): any => {
  return (
    <>
      {time?.startStr ? (
        <>
          {`${time?.startStr}:00`}
          <span style={{ padding: '0px 8px' }}>至</span>
          {time?.isPermanent ? '永久' : `${time?.endStr}:00`}
        </>
      ) : (
        <>
          {formatTimestamp(time?.start, 'UTC+08:00', 'YYYY-MM-DD HH:mm:ss')}
          <span style={{ padding: '0px 8px' }}>至</span>
          {time?.isPermanent ? '永久' : formatTimestamp(time?.end, 'UTC+08:00', 'YYYY-MM-DD HH:mm:ss')}
        </>
      )}
    </>
  );
};
//时间范围显示（纯文字版本，不用html）
export const timeRangerShowByWord = (time: ITime): any => {
  return time?.startStr
    ? `${time?.startStr}:00 至 ${time.isPermanent ? '永久' : `${time.endStr}:00`}`
    : `${formatTimestamp(time.start, 'UTC+08:00', 'YYYY-MM-DD HH:mm:ss')} 至 ${
        time.isPermanent ? '永久' : formatTimestamp(time.end, 'UTC+08:00', 'YYYY-MM-DD HH:mm:ss')
      }`;
};
// 返回 2023年09月13日 14:50至2023年09月13日 14:50(UTC+08:00)格式
export function getTimeStr(params: { start: number; end: number; timeZone?: IUTC; format?: string }) {
  const { start, end, timeZone = 'UTC+08:00', format = 'YYYY年MM月DD日 HH:mm' } = params;
  return `${formatTimestamp(start, timeZone, format)} 至 ${formatTimestamp(end, timeZone, format)}`;
}
const formatStr = 'YYYY-MM-DD HH:mm';
export function getLocalTime(timestamp: number, utc: IUTC = 'UTC+08:00') {
  const str = formatTimeZone(timestamp, utc, formatStr);

  return dayjs(str);
}
